import {
  Component,
  DestroyRef,
  HostListener,
  inject,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CourseModel } from '@models/course/course.model';
import { QuantitySelectorComponent } from '@components/quantity-selector/quantity-selector.component';
import { FormatPricePipe } from '@pipes/format-price.pipe';

@Component({
  selector: 'app-course-card',
  standalone: true,
  imports: [TranslateModule, QuantitySelectorComponent, FormatPricePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './course-card.component.html',
})
export class CourseCardComponent {
  course = input.required<CourseModel>();
  quantity = input.required<number>();
  showPrice = input.required<boolean>();
  disabled = input<boolean>(false);
  readOnly = input<boolean>(false);
  bgColor = input<string | null>(null);
  imageUrl = input<string | null>(null);

  increment = output<void>();
  decrement = output<void>();

  readonly showInfoTooltip = signal(false);
  readonly tooltipPosition = signal<{ top: number; left: number }>({ top: 0, left: 0 });
  readonly brokenLogoKeys = signal<Set<string>>(new Set());

  #onScroll = (): void => this.showInfoTooltip.set(false);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    document.addEventListener('scroll', this.#onScroll, true);
    this.destroyRef.onDestroy(() => document.removeEventListener('scroll', this.#onScroll, true));
  }

  toggleInfoTooltip(event: MouseEvent): void {
    event.stopPropagation();
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.tooltipPosition.set({ top: rect.bottom + 4, left: rect.left });
    this.showInfoTooltip.update((visible) => !visible);
  }

  @HostListener('document:click')
  closeInfoTooltip(): void {
    this.showInfoTooltip.set(false);
  }

  markLogoBroken(key: string): void {
    this.brokenLogoKeys.update((keys) => new Set(keys).add(key));
  }
}
